import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { LogoWrapper } from '@coursera/cds-core';

export type Props = {
  src: string;
  alt: string;
  overrideMaxHeight?: number;
  overrideMaxWidth?: number;
};

const DefaultLogoImage = ({ src, alt, overrideMaxHeight, overrideMaxWidth }: Props) => {
  return (
    <LogoWrapper paddingVariant="smallOutside">
      <Imgix src={src} maxWidth={overrideMaxWidth || 160} maxHeight={overrideMaxHeight || 32} alt={alt} />
    </LogoWrapper>
  );
};

export default DefaultLogoImage;
